import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { DollarSign } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function ArchitectsEngineersFeasibilityPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Relatório de Viabilidade"
      description="Análise de viabilidade financeira dos seus projetos."
      icon={DollarSign}
    />
  
    </MainLayout>);
}

